import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Empty, Image } from 'antd';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import UcPng from '@Images/admin/integrations/unicommerce.png';
import './style.scss';
import '../../../../../scss/integration.scss'

/**
 *
 */
function UnicommerceHome({
  getUnicommerceConnections, user, getUnicommerceConnectionsLoading,
  history, unicommerceConnections,
}) {
  useEffect(() => {
    getUnicommerceConnections(user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    if (unicommerceConnections?.success) {
      history.push('/admin/integration/unicommerce/setup');
    }
  }, [unicommerceConnections]);

  return (
    <div className="integration-home__wrapper">
      <div className="integration-home__header">
        <div className="flex-display flex-align-c">
          <Image src={UcPng} className="integration-home__heading"  preview={false} />
          &nbsp;
          Unicommerce
        </div>
        <Button
          type="primary"
          loading={getUnicommerceConnectionsLoading}
          onClick={() => {
            const id = 'new Account';
            history.push('/admin/integration/unicommerce/setup');
          }}
        >
          + New Connection
        </Button>
      </div>


      { !getUnicommerceConnectionsLoading ? (
        <React.Fragment>
          <div className="integration-empty-state__wrapper">
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description=""
            />
            <p className="integration-empty-state__heading">Your Procuzy account is not yet connected to unicommerce</p>
            <div>
              <Button
                type="primary"
                onClick={() => {
                  history.push('/admin/integration/unicommerce/setup');
                }}
              >
                Connect Now
              </Button>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="integration-home__wrapper">
          {
            [1, 2].map((item) => (
              <div
                key={item}
                className="integration-card__loading"
              >
                <div className="integration-card-spacing">
                  <div className="integration-card-header">
                    <div className="loadingBlock integration-card__loading__header-text" />
                    <div className="loadingBlock integration-card__loading__header-image"> </div>
                  </div>
                  <div className="integration-card__loading__link" />
                  <div className="integration-card__loading__footer" />
                </div>
              </div>
            ))
          }
        </div>
      ) }
    </div>
  );
}

const mapStateToProps = ({ UnicommerceIntegrationReducers, UserReducers }) => ({
  unicommerceConnections: UnicommerceIntegrationReducers.unicommerceConnections,
  getUnicommerceConnectionsLoading: UnicommerceIntegrationReducers.getUnicommerceConnectionsLoading,
  user: UserReducers.user,

});
const mapDispatchToProps = (dispatch) => ({
  getUnicommerceConnections: (orgId, callback) => dispatch(UnicommerceIntegrationActions.getUnicommerceConnections(orgId, callback)),

});
UnicommerceHome.propTypes = {
  history: PropTypes.any,
  user: PropTypes.any,
  unicommerceConnections: PropTypes.any,
  getUnicommerceConnectionsLoading: PropTypes.bool,
  getUnicommerceConnections: PropTypes.func,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnicommerceHome));
